import * as api from '../../api';
import { pagingDataUtilities } from '../../common';
import { participantTypeHelpers } from '../../participant-types';

export const fetchSettingsActions = api.fetchActions('demographics', 'fetch-settings');
export const fetchSitesActions = api.fetchActions('demographics', 'fetch-sites');
export const fetchDemographicsActions = api.fetchActions('demographics', 'allDemographics');
export const saveActions = api.fetchActions('demographics', 'save');
export const pagingActions = pagingDataUtilities.pagingActions('demographics', 'paging');

export const actionTypes = {
  ...fetchSettingsActions.actionTypes,
  ...fetchSitesActions.actionTypes,
  ...saveActions.actionTypes,
  ...fetchDemographicsActions.actionTypes,
  ...pagingActions.actionTypes,
  CLEAR_ANSWERS : 'demographics.clear-answers',
  UPDATE_SITE: "demographics.update-site",
  UPDATE_PERMISSION: "demographics.update-permisssion",
  SHOW_CONFIRM_SETTINGS_MODAL_DEMO_ENABLED : 'demographics.show-confirm-settings-modal-demo-enabled',
  SHOW_CONFIRM_SETTINGS_MODAL_DEMO_DISABLED : 'demographics.show-confirm-settings-modal-demo-disabled',
  SET_SELECTED_SAVE_OPTION : 'demographics.set-selected-save-option',
  UPDATE_DEMOGRAPHICS_ENABLED : 'demographics.set-demographics-enabled',
};

export const fetchSettings = () => api.shouldExecute(['demographics', 'settings'],
  api.getThunk(`/demographics-permissions/settings`, {participantTypeId: participantTypeHelpers.getParticipantTypeId()}, fetchSettingsActions));

export const fetchSites = () => api.shouldExecute(['demographics', 'sites'],
  api.getThunk(`/sites/all`, null, fetchSitesActions));

export function fetchDemographicPermissions() {
  return (dispatch, getState) => {
    const state = getState();
    const { demographics } = state;
    const { demographicsPagingData } = demographics;
    const { currentPage, itemsPerPage } = demographicsPagingData || {};
    const params = {
      participantTypeId: participantTypeHelpers.getParticipantTypeId(),
      page: currentPage,
      perPage: itemsPerPage,
    };
    return dispatch(api.shouldExecute(['demographics', 'allDemographics'],
      api.getThunk(`/demographics-permissions/all-permissions`, params, fetchDemographicsActions)))
  }
}

export function saveSettings() {
  return (dispatch, getState) => {
    const state = getState();
    const { demographics } = state;
    const { permissionsResponse } = demographics;
    const data = permissionsResponse && permissionsResponse.toJS();
    const request = {
      ...data,
      participantTypeId: participantTypeHelpers.getParticipantTypeId(),
    }
    return dispatch(api.postThunk(`/demographics-permissions`, request, saveActions));
  }
}

export function updateSite(siteId) {
  return {
    type: actionTypes.UPDATE_SITE,
    siteId
  }
}

export function updatePermission(demographicId, section, value) {
  return {
    type: actionTypes.UPDATE_PERMISSION,
    demographicId,
    section,
    value,
  }
}

export const changePageNumber = (page) => pagingDataUtilities.changePage(page, pagingActions);
export const changeSort = (newSort) => pagingDataUtilities.changeSort(newSort, pagingActions, ['demographics', 'demographicsPagingData']);
export const changeResultsPerPage = (perPage) => pagingDataUtilities.changePerPage(perPage, pagingActions, ['demographics', 'demographicsPagingData']);

export function showConfirmSettingsModalDemoEnabledAction(show) {
  return {
    type: actionTypes.SHOW_CONFIRM_SETTINGS_MODAL_DEMO_ENABLED,
    show
  }
}

export function showConfirmSettingsModalDemoDisabledAction(show) {
  return {
    type: actionTypes.SHOW_CONFIRM_SETTINGS_MODAL_DEMO_DISABLED,
    show
  }
}

export function setSelectedSaveOption(optionId) {
  return {
    type: actionTypes.SET_SELECTED_SAVE_OPTION,
    optionId
  }
}

export function setDemographicsEnabled(enabled) {
  return {
    type: actionTypes.UPDATE_DEMOGRAPHICS_ENABLED,
    enabled
  }
}

export function clearChanges() {
  return {
    type: actionTypes.CLEAR_ANSWERS
  }
}
